import { useEffect, useRef, useState } from 'react';
import chiffrageSiteService from '../services/chiffrageSiteService';

export function useChiffrageEntrepriseSearch(query, minLength = 2) {
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const timerRef = useRef(null);
  const abortRef = useRef(null);

  useEffect(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    if (abortRef.current) {
      abortRef.current.abort();
      abortRef.current = null;
    }

    const q = String(query ?? '').trim();
    if (q.length < minLength) {
      setSuggestions([]);
      setLoading(false);
      return undefined;
    }

    setLoading(true);
    timerRef.current = setTimeout(async () => {
      const controller = new AbortController();
      abortRef.current = controller;
      try {
        const thirdparties = await chiffrageSiteService.searchDolibarrThirdparties(q, {
          signal: controller.signal,
        });
        if (!controller.signal.aborted) {
          setSuggestions(thirdparties);
        }
      } catch (err) {
        if (err?.name === 'AbortError' || controller.signal.aborted) {
          return;
        }
        setSuggestions([]);
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    }, 250);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      if (abortRef.current) {
        abortRef.current.abort();
        abortRef.current = null;
      }
    };
  }, [query, minLength]);

  return { suggestions, loading };
}
